import React from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Tengo que hacer una dieta muy estricta?',
    a: 'No. El protocolo trabaja CON tus hábitos actuales, no contra ellos. No te pedimos que renuncies a tu vida social ni que pases hambre.'
  }, {
    q: '¿Funciona si tengo más de 45 años?',
    a: 'El protocolo está diseñado específicamente para mujeres a partir de los 35, cuando la inflamación silenciosa es más activa. Muchas de las mejores transformaciones vienen de mujeres entre 45 y 55.'
  }, {
    q: '¿Cuándo recibo el acceso?',
    a: 'Inmediatamente después del pago. Recibes un email con tus credenciales en menos de 2 minutos.'
  }, {
    q: '¿Necesito comprar productos o suplementos especiales?',
    a: 'No. Todo el protocolo se basa en alimentos que encuentras en cualquier supermercado español. Sin suplementos, sin kits, sin gastos extra.'
  }, {
    q: '¿Y si no me funciona?',
    a: 'Tienes 15 días de garantía total. Si sigues el protocolo y no notas ninguna diferencia, te devolvemos el 100% de tu dinero. Solo un email. Sin formularios. Sin excusas de nuestra parte.'
  }, {
    q: '¿Es seguro pagar online?',
    a: 'Sí. El pago se procesa a través de plataformas certificadas con cifrado SSL. Nunca almacenamos datos de tu tarjeta.'
  }, {
    q: '¿Cuánto tiempo al día necesito dedicarle?',
    a: 'Entre 15 y 30 minutos diarios. Está diseñado para mujeres con vida ocupada.'
  }];
  return <section className="bg-brand-cream py-20 px-4 sm:px-6 lg:px-8" data-id="element-16">
      <div className="max-w-3xl mx-auto" data-id="element-17">
        <div className="text-center mb-12" data-id="element-18">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-brand-dark" data-id="element-19">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-20">
          {faqs.map((faq, index) => <details key={index} className="bg-white rounded-xl border border-brand-gold/20 overflow-hidden shadow-sm group" data-id="element-21">
              <summary className="w-full px-6 py-5 text-left flex justify-between items-center cursor-pointer focus:outline-none" data-id="element-22">
                <span className="font-bold text-brand-dark text-lg pr-4" data-id="element-23">
                  {faq.q}
                </span>
                <ChevronDown className="w-5 h-5 text-brand-gold transition-transform duration-300 flex-shrink-0 group-open:rotate-180" data-id="element-24" />
              </summary>
              <div className="px-6 pb-5 text-brand-gray text-[17px] leading-relaxed border-t border-gray-100 pt-4" data-id="element-25">
                {faq.a}
              </div>
            </details>)}
        </div>
      </div>
    </section>;
}